export interface StringFilter {
  [key: string]: string[];
}

export function stringifyFilter(stringFilter: StringFilter): string | null {
  const keys = Object.keys(stringFilter);
  if (keys.length === 0) {
    return null;
  }

  const clearedFilter: StringFilter = {};
  for (const key of keys) {
    const filters = stringFilter[key];
    if (filters && filters.length > 0) {
      clearedFilter[key] = filters;
    }
  }

  if (Object.keys(clearedFilter).length === 0) {
    return null;
  }

  return JSON.stringify(clearedFilter);
}
